var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uploadfile" },
    [
      !_vm.disableEdit
        ? _c(
            "el-button",
            {
              staticClass: "upload-btn",
              attrs: {
                size: "mini",
                block: "",
                disabled: _vm.disableUploadBtn,
              },
              on: { click: _vm.onUploadClick },
            },
            [
              _c("img", { attrs: { src: _vm.UploadIcon } }),
              _c("input", {
                ref: "file",
                staticClass: "files",
                staticStyle: { display: "none" },
                attrs: { type: "file", multiple: "multiple" },
                on: { change: _vm.onFileChange },
              }),
              _vm._v(
                "\n        " + _vm._s(_vm.$t("ita_choose_files")) + "\n    "
              ),
            ]
          )
        : _vm._e(),
      !_vm.disableEdit
        ? _c("div", { staticClass: "tip" }, [
            _vm._v(_vm._s(_vm.$t("ita_upload_tip"))),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "files" },
        _vm._l(_vm.hereValue, function (v, k) {
          return _c("div", { key: k, staticClass: "file-item" }, [
            _c(
              "div",
              {
                class: [
                  v.status == "success" ? "filename-success" : "filename",
                ],
                on: {
                  click: () =>
                    _vm.canDownload(v) ? _vm.onDownloadClick(v) : () => {},
                },
              },
              [
                _vm._v(
                  "\n                " + _vm._s(v.fileName) + "\n            "
                ),
              ]
            ),
            _c("div", { staticClass: "btns" }, [
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.canDownload(v) && !v.downloadLoading,
                    expression: "canDownload(v) && !v.downloadLoading",
                  },
                ],
                staticClass: "btn el-icon-download",
                on: {
                  click: function ($event) {
                    return _vm.onDownloadClick(v)
                  },
                },
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: v.status == "success" && v.downloadLoading,
                    expression: "v.status == 'success' && v.downloadLoading",
                  },
                ],
                staticClass: "btn el-icon-loading",
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: v.status == "success",
                    expression: "v.status == 'success'",
                  },
                ],
                staticClass: "btn el-icon-circle-check",
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: v.status == "uploading",
                    expression: "v.status == 'uploading'",
                  },
                ],
                staticClass: "btn el-icon-loading",
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: v.status == "failed",
                    expression: "v.status == 'failed'",
                  },
                ],
                staticClass: "btn el-icon-warning",
              }),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: v.status != "uploading" && !_vm.disableEdit,
                    expression: "v.status != 'uploading' && !disableEdit",
                  },
                ],
                staticClass: "btn el-icon-delete",
                on: {
                  click: function ($event) {
                    return _vm.onDeleteClick(k)
                  },
                },
              }),
            ]),
          ])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }